export const css = {
	root: '_3v6aot9o',
	' _key': 'ascm-theme/ascm/variants/cscp2024ss'
};

export default css;
